import React from 'react';
import { Box, Typography } from '@mui/material';
import ItemPurchaseSummary from '../../components/Reports/ItemPurchaseSummary';

const ItemPurchaseSummaryPage: React.FC = () => {
  return (
    <Box sx={{ width: '100%', p: 0 }}>
      <ItemPurchaseSummary type="item-purchase-summary" />
    </Box>
  );
};

export default ItemPurchaseSummaryPage;
